import { combineReducers } from 'redux';
import auth from './auth';
import geoIp from './geo-ip';
import fuelReport from './fuelReport';
import user from './user';
import config from './config';
import marketing from './marketing';
import ubi from './ubi';
import membership from './membership';
import home from './home';

export default combineReducers({
  auth,
  geoIp,
  fuelReport,
  user,
  config,
  marketing,
  ubi,
  membership,
  home,
});
